export default __webpack_public_path__ + "static/media/viber_image_2022-05-25_11-14-37-668.47db43b9.jpg";